import { Action } from "../actions";
import { PageAlertActionTypes } from "../constants";

export interface PageAlertState {
  show: boolean;
  type: string;
  message: string;
  iconClass?: string;
}

const DEFAULT_PAGE_ALERT_STATE: PageAlertState = {
  type: "",
  message: "",
  show: false,
  iconClass: "caprx-icon-formulary",
};

export default function pageAlertReducer(state: PageAlertState = DEFAULT_PAGE_ALERT_STATE, action: Action): PageAlertState {
  if (action.type === PageAlertActionTypes.SHOW_PAGE_ALERT) {
    return { ...state, ...action.payload };
  } else if (action.type === PageAlertActionTypes.HIDE_PAGE_ALERT) {
    return { ...state, ...DEFAULT_PAGE_ALERT_STATE };
  } else {
    return state;
  }
}
